import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../utils/analytics";

function AnalyticsTracker({moduleName}) {
  const location = useLocation();
  const currentUser = JSON.parse(localStorage.getItem("user"))
  const userId = currentUser?._id;
  useEffect(() => {
    trackPageView(location.pathname,moduleName,userId);
  }, [location]);

  return null;
}

export default AnalyticsTracker;